import { render, staticRenderFns } from "./OauthLogin.vue?vue&type=template&id=5953c93a"
import script from "./OauthLogin.vue?vue&type=script&lang=ts"
export * from "./OauthLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports